export default {
  isConnected: true,
  networkInfo: { wifi_name: null, wifi_mac: null, wifi_connected_at: null },
};
